import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';
import { ACCESS_MANAGEMENT } from '@store/constants';
import {ALERT_STATUS_TYPE as ALERT_STATUS_TYPE} from "@constants";


export const getAllUserPermissions = () => async (dispatch) => {
  try {
    dispatch({ type: ACCESS_MANAGEMENT.GET_USER_PERMISSIONS });
    const { data } = await api.accessManagement.getAllUserPermissions();
    dispatch({ type: ACCESS_MANAGEMENT.GET_USER_PERMISSIONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: ACCESS_MANAGEMENT.GET_USER_PERMISSIONS_FAILURE, payload: error });
    dispatch(
      setAlert({
        title: 'Failed to fetch user permissions',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  }
};

export const updateUserPermissions = ({ name, userId, rolesToAdd, rolesToRemove, onSuccess, onError }) => async (dispatch) => {
  try {
    dispatch({ type: ACCESS_MANAGEMENT.UPDATE_USER_PERMISSIONS });
    await api.accessManagement.updateUserPermissions(userId, {
      roles_to_add: rolesToAdd,   // New structure for roles to add
      roles_to_remove: rolesToRemove // New structure for roles to remove
    });
    dispatch({
      type: ACCESS_MANAGEMENT.UPDATE_USER_PERMISSIONS_SUCCESS,
      payload: { userId, rolesToAdd, rolesToRemove },
    });
    onSuccess();
  } catch (error) {
    dispatch({
      type: ACCESS_MANAGEMENT.UPDATE_USER_PERMISSIONS_FAILURE,
      payload: error,
    });
    onError(error);
  }

  
};

export const getAllRoles = () => async (dispatch) => {
  try {
    dispatch({ type: ACCESS_MANAGEMENT.GET_ALL_ROLES });
    const { data } = await api.accessManagement.getAllRoles();
    dispatch({ type: ACCESS_MANAGEMENT.GET_ALL_ROLES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: ACCESS_MANAGEMENT.GET_ALL_ROLES_FAILURE, payload: error });
    dispatch(
      setAlert({
        title: 'Failed to fetch roles',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  }
};

export const createUser = (userData) => async (dispatch) => {
  try {
    const response = await api.accessManagement.createUser(userData);
    dispatch({
      type: ACCESS_MANAGEMENT.CREATE_USER_SUCCESS,
      payload: "Success"
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: ACCESS_MANAGEMENT.CREATE_USER_FAILURE,
      payload: error.message
    });
    throw error;
  }
};
